var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"saved-page"},[_c('h2',[_vm._v("My list")]),(_vm.data.saved.length == 0)?_c('div',{staticClass:"no-content"},[_vm._v("There is no saved content.")]):_c('div',{staticClass:"saved"},_vm._l((_vm.data.saved),function(content){return _c('Card',{key:content.id,attrs:{"content":content,"searched":true}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }